<template>
    <div>
        <button
            type="button"
            class="btn text-sm is-ghost is-danger"
            href="#"
            @click="$modal.show('delete-supplier')"
        >
            Radera
        </button>
        <adaptive-form-modal
            name="delete-supplier"
            :primary-button-text="buttonText"
            primary-button-class="is-danger"
            title="Radera avtalspart"
            :redirect-to="redirectRoute"
            method="delete"
            :action="actionRoute"
        >
            <p>Vill du verkligen radera {{ supplier.name }}?</p>
            <p v-if="productCount > 0">
                <strong>
                    <span v-if="productCount == 1">
                        Denna avtalspart är kopplad till en kampanj, denna koppling kommer att försvinna.
                    </span>
                    <span v-else>
                        Denna avtalspart är kopplad till {{ productCount }} kampanjer, dessa kopplingar kommer att försvinna.
                    </span>
                </strong>
            </p>
        </adaptive-form-modal>
    </div>
</template>

<script>
    import AdaptiveFormModal from '../../../shared/components/Base/Modals/AdaptiveFormModal.vue';

    export default {

        components: {
            AdaptiveFormModal,
        },
        props: {
            supplier: {
                type: Object,
                required: true,
            },
            productCount: {
                type: Number,
                required: true,
            },
        },

        computed: {
            buttonText() {
                return `Radera ${this.supplier.name}`;
            },
            actionRoute() {
                return route('admin.suppliers.destroy', this.supplier);
            },
            redirectRoute() {
                return route('admin.suppliers.index');
            },
        },
    };
</script>
